import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import DashboardComponent from './DashboardComponent';
import { actionCreators as devicesActionCreators } from "../../actions/devicesActions";
import { actionCreators as uiActionCreators } from "../../actions/uiActions";
import { actionCreators as userActionCreators } from "../../actions/userActions";
import { actionCreators as sensorHistoActionCreators } from "../../actions/sensorHistoActions";



const mapStateToProps = (state) => {
  let drag = state.ui.drag;
  let isActiveDrag = drag.active && drag.source && drag.source.type;
  let isWidgetDrag = isActiveDrag && drag.source.type === "widget";

  return {
    devices: [...state.devices],
    widgetConfig: state.widgetConfig,
    ui: state.ui,
    uiConfig: state.uiConfig,
    isWidgetDrag
  }
};

function mapDispatchToProps(dispatch) {
    // Explicitly add the dispatch function to props
    return {dispatch, ...bindActionCreators({ ...devicesActionCreators, ...uiActionCreators, ...userActionCreators, ...sensorHistoActionCreators }, dispatch)}
}

const DashboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardComponent);

export default DashboardContainer;